import { PagesModule } from 'pages/pages.module';
import { NgModule } from '@angular/core';
import { ComponentsModule } from 'components/components.module';
import { PurchaseSuccessPage } from 'pages/purchase-success/purchase-success';

@NgModule({
  declarations: [PurchaseSuccessPage],
  imports: [PagesModule, ComponentsModule],
  exports: [PurchaseSuccessPage]
})
export class PurchaseSuccessPageModule { }
